import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import DynamicColumnChart from "../../../components/columnChart";

const WarehouseChart = (props) => {
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [cropwiseSalesFilter, setCropwiseSalesFilter] = useState(
    "RegionCropwiseSales"
  );
  const [cropwiseSalesReturnFilter, setcropwiseSalesReturnFilter] = useState(
    "RegionCropwiseSalesReturn"
  );
  const [productwiseSalesFilter, SetProductwiseSalesFilter] = useState(
    "RegionProductwiseSales"
  );

  const [expenseData, setExpenseData] = useState([]);
  const [cropwiseSalesData, setCropwiseSalesData] = useState([]);
  const [cropwiseSalesReturnData, setCropwiseSalesReturnData] = useState([]);
  const [productwiseSalesData, setProductwiseSalesData] = useState([]);
  const [customerwiseSalesData, setCustomerwiseSalesData] = useState([]);
  const [productWiseChartQty, setProductWiseChartQty] = useState([]);
  const [productWiseChartQtyData, setProductWiseChartQtyData] = useState([]);

  const [cropwiseChartQty, setCropwiseChartQty] = useState([]);
  const [cropwiseChartQtyData, setCropwiseChartQtyData] = useState([]);

  const [
    executivewiseCropSalesReturnData,
    setExecutivewiseCropSalesReturnData,
  ] = useState([]);
  const [executivewiseCropSalesData, setExecutivewiseCropSalesData] = useState(
    []
  );
  const [expenseRegionData, setExpenseRegionData] = useState([]);
  const [regionProductwiseSalesData, setRegionProductwiseSalesData] = useState(
    []
  );
  const [regionCustomerwiseSalesData, setRegionCustomerwiseSalesData] =
    useState([]);

  const [goodsIssueData, setGoodsIssueData] = useState([]);

  const [executivewiseGoodsIssueData, setExecutivewiseGoodsIssueData] =
    useState([]);

  //  New State
  const [cropwiseAreacoveredAll, setCropwiseAreacoveredAll] = useState([]);
  const [cropwiseAreacovered, setCropwiseAreacovered] = useState([]);
  const [regionCropArea, setRegionCropArea] = useState("--All--");

  const [cropwiseHarvestAll, setCropwiseHarvestAll] = useState([]);
  const [cropwiseHarvest, setCropwiseHarvest] = useState([]);
  const [regionCropsHarvest, setRegionCropsHarvest] = useState("--All--");

  const [cropwiseYieldEstiamtionAll, setCropwiseYieldEstiamtionAll] = useState(
    []
  );
  const [cropwiseYieldEstiamtion, setCropwiseYieldEstiamtion] = useState([]);
  const [regionCropsYieldEstiamtion, setRegionCropsYieldEstiamtion] =
    useState("--All--");

  const [
    cropwiseYieldEstiamtionVSHarvestAll,
    setCropwiseYieldEstiamtionVSHarvestAll,
  ] = useState([]);
  const [
    cropwiseYieldEstiamtionVSHarvest,
    setCropwiseYieldEstiamtionVSHarvest,
  ] = useState([]);
  const [
    regionCropsYieldEstiamtionVSHarvest,
    setRegionCropsYieldEstiamtionVSHarvest,
  ] = useState("--All--");

  const { sendRequest: getproductWiseChartQtyData } = useHttp();

  const fillProductWiseChartQtyData = (employeeId, regionId) => {
    //console.log("fillProductWiseChartQtyData start")
    var urlfilter = "";
    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/productWiseChartQty/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    getproductWiseChartQtyData(
      {
        url: url,
      },
      (data) => {
        //console.log("productWiseChartQty", data);

        var productWiseQtyresult = data.productWiseQtyresult;

        // //console.log("inewList", newList);
        setProductWiseChartQtyData(productWiseQtyresult);
        loadProductWiseChartQtyData(productWiseQtyresult, 0);
      }
    );
  };
  useEffect(() => {
    fillProductWiseChartQtyData(0);
  }, [getproductWiseChartQtyData]);

  const loadProductWiseChartQtyData = (data, id) => {
    if (data && data.length > 0) {
      var tempData = data;

      //console.log("loadProductWiseChartQtyData",data)
      var croplist = [...new Set(tempData.map((q) => q.productName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.productName == croplist[i]
        );
        var unitAbbreviation = "";
        var totalQty = 0;
        var totalValue = 0;
        selectedcroplist.forEach((item) => {
          totalQty += parseFloat(item.totalQty || 0);
          totalValue += parseFloat(item.totalValue || 0);
          unitAbbreviation = item.unitAbbreviation;
        });

        var totalplotAreaUnit = "Arce";

        newcropData = newcropData.concat({
          productName: croplist[i],
          totalQty: totalQty,
          totalValue: totalValue,
          unitAbbreviation: unitAbbreviation,
        });

        i++;
      } while (croplist.length > i);

      setProductWiseChartQty(newcropData);
    }
  };

  const { sendRequest: getCropwiseChartQtyData } = useHttp();

  const fillCropwiseChartQtyData = (employeeId, regionId) => {
    //console.log("fillProductWiseChartQtyData start")
    var urlfilter = "";
    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/cropwiseChartQty/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    getCropwiseChartQtyData(
      {
        url: url,
      },
      (data) => {
        //console.log("productWiseChartQty", data);

        var productWiseQtyresult = data.productWiseQtyresult;

        // //console.log("inewList", newList);
        setCropwiseChartQtyData(productWiseQtyresult);
        loadCropwiseChartQtyData(productWiseQtyresult, 0);
      }
    );
  };
  useEffect(() => {
    fillCropwiseChartQtyData(0);
  }, [getCropwiseChartQtyData]);

  const loadCropwiseChartQtyData = (data, id) => {
    if (data && data.length > 0) {
      var tempData = data;

      //console.log("loadProductWiseChartQtyData",data)
      var croplist = [...new Set(tempData.map((q) => q.productName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.productName == croplist[i]
        );
        var unitAbbreviation = "";
        var totalQty = 0;
        var totalValue = 0;
        selectedcroplist.forEach((item) => {
          totalQty += parseFloat(item.totalQty || 0);
          totalValue += parseFloat(item.totalValue || 0);
          unitAbbreviation = item.unitAbbreviation;
        });

        var totalplotAreaUnit = "Arce";

        newcropData = newcropData.concat({
          productName: croplist[i],
          totalQty: totalQty,
          totalValue: totalValue,
          unitAbbreviation: unitAbbreviation,
        });

        i++;
      } while (croplist.length > i);

      setCropwiseChartQty(newcropData);
    }
  };

  const { sendRequest: getGoodsIssueData } = useHttp();

  const { sendRequest: getProductData } = useHttp();

  const fillGoodsIssueData = (employeeId, regionId) => {
    var urlfilter = "";
    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/farmerGoodsIssuereport/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    var productMasterData = [];

    getProductData(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          productMasterData = res;

          getGoodsIssueData(
            {
              url: url,
            },
            (data) => {
              //  //console.log("GI reportdata", data);

              var goodsIssueData = data;
              var newList = [];
              var i = 0;
              do {
                var farmeritem = goodsIssueData[i];
                //  //console.log("farmeritem", farmeritem);

                if (farmeritem.goodsIssue.length > 0) {
                  //  //console.log("farmeritem.goodsIssue", farmeritem.goodsIssue);
                  var strgoodsIssue = JSON.stringify(farmeritem.goodsIssue);

                  var goodsIssue = JSON.parse(strgoodsIssue);

                  var j = 0;

                  do {
                    var goodsIssueitem = goodsIssue[j];
                    var strproductDetails = JSON.stringify(
                      goodsIssueitem.productDetails
                    );
                    var productDetails = JSON.parse(
                      JSON.parse(strproductDetails)
                    );
                    //  //console.log("productDetails", productDetails);

                    var k = 0;

                    do {
                      var productItem = productDetails[k];

                      var newList = newList.concat({
                        fieldExecutiveName: farmeritem.executiveName,
                        regionName: farmeritem.regionName,
                        fieldExecutiveId: farmeritem.fieldExecutiveId,
                        regionId: farmeritem.regionId,
                        farmerNo: farmeritem.farmerNo,
                        farmerName: farmeritem.farmerName,
                        goodsIssueDate: goodsIssueitem.goodsIssueDate,
                        totalAmount: goodsIssueitem.totalAmount,
                        discountAmount: goodsIssueitem.discountAmount,
                        discount: goodsIssueitem.discount,
                        productName: productItem.productName,
                        productId: productItem.productId,
                        Quantity: productItem.Quantity,
                        unitAbbreviation: productItem.unitAbbreviation,
                        amount: productItem.useAmt,
                      });

                      k++;
                    } while (productDetails.length > k);

                    j++;
                  } while (goodsIssue.length > j);
                }

                i++;
              } while (goodsIssueData.length > i);

              //  //console.log("Product newList", newList);

              var fieldExecutiveNamelist = [
                ...new Set(newList.map((q) => q.fieldExecutiveName)),
              ];

              var productIdlist = [...new Set(newList.map((q) => q.productId))];

              i = 0;
              var newProductList = [];
              do {
                var j = 0;
                do {
                  var selectedcroplist = newList.filter(
                    (item) =>
                      item.productId == productIdlist[j] &&
                      item.fieldExecutiveName == fieldExecutiveNamelist[i]
                  );

                  var totalAmount = 0;

                  selectedcroplist.forEach((item) => {
                    totalAmount += parseFloat(item.amount || 0);
                  });

                  var productTypeName = "";
                  var productSubTypeName = "";

                  if (parseFloat(totalAmount) > 0) {
                    var dataitem = selectedcroplist[0];
                    var itemlist = productMasterData.filter(
                      (item) => item.productId == dataitem.productId
                    );

                    if (itemlist.length > 0) {
                      productTypeName = itemlist[0].productTypeName;
                      productSubTypeName = itemlist[0].productSubTypeName;
                    }

                    var newProductList = newProductList.concat({
                      fieldExecutiveName: dataitem.fieldExecutiveName,
                      regionName: dataitem.regionName,

                      fieldExecutiveId: dataitem.fieldExecutiveId,
                      regionId: dataitem.regionId,

                      productId: dataitem.productId,
                      totalAmount: totalAmount,
                      productTypeName: productTypeName,
                      productSubTypeName: productSubTypeName,
                    });
                  }
                  j++;
                } while (productIdlist.length > j);

                i++;
              } while (fieldExecutiveNamelist.length > i);

              //  //console.log("newProductList",newProductList);
              setGoodsIssueData(newProductList);
              loadGoodsIssueFilterData(newProductList, 0);
            }
          );
        }
      }
    );
  };
  useEffect(() => {
    fillGoodsIssueData(0);
  }, [getGoodsIssueData]);

  const loadGoodsIssueFilterData = (data, id) => {
    //  //console.log("loadGoodsIssueFilterData")
    if (data && data.length > 0) {
      var tempData = data;

      //  //console.log("id",id)
      //  //console.log("data",data)

      // if (id != 0) {
      //   // ExecutiveCropwiseArea
      //   // RegionCropwiseArea
      //   if (cropwiseProcurementFilter == "RegionCropwiseArea") {
      //     tempData = data.filter((item) => item.regionId == id);
      //   } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      // }

      ////  //console.log("loadCropPaymentFilterData tempData",tempData)

      var productTypeNamelist = [
        ...new Set(tempData.map((q) => q.productTypeName)),
      ];
      //  //console.log('productTypeNamelist',productTypeNamelist);
      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.productTypeName == productTypeNamelist[i]
        );

        var totalAmount = 0;
        selectedcroplist.forEach((item) => {
          totalAmount += parseFloat(item.totalAmount || 0);
        });

        newcropData = newcropData.concat({
          productTypeName: productTypeNamelist[i],
          Amount: totalAmount,
        });

        i++;
      } while (productTypeNamelist.length > i);

      //console.log("setExecutivewiseGoodsIssueData", newcropData);
      setExecutivewiseGoodsIssueData(newcropData);
    }
  };

  const data = [
    {
      label: "Apple.",
      type: "Yield",
      value: 2800,
    },
    {
      label: "Apple.",
      type: "Harvest",
      value: 2260,
    },
    {
      label: "Banana.",
      type: "Yield",
      value: 1800,
    },
    {
      label: "Banana.",
      type: "Harvest",
      value: 1300,
    },
    {
      label: "Tomato.",
      type: "Yield",
      value: 950,
    },
    {
      label: "Tomato.",
      type: "Harvest",
      value: 900,
    },
    {
      label: "Bell Paper.",
      type: "Yield",
      value: 500,
    },
    {
      label: "Bell Paper.",
      type: "Harvest",
      value: 390,
    },
    {
      label: "Pineapple.",
      type: "Yield",
      value: 170,
    },
    {
      label: "Pineapple.",
      type: "Harvest",
      value: 100,
    },
  ];

  const ProductWiseChartQtyconfig = {
    data: productWiseChartQty,
    xField: "productName",
    yField: "totalQty",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Quantity",
      },
    },
    yAxis: {
      title: {
        text: "Product",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Area",
      },
      quantityBal: {
        alias: "Total Area",
      },
    },
  };

  const ProductWiseChartValueConfig = {
    data: productWiseChartQty,
    xField: "productName",
    yField: "totalValue",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Amount",
      },
    },
    yAxis: {
      title: {
        text: "Product",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Area",
      },
      quantityBal: {
        alias: "Total Area",
      },
    },
  };

  const CropWiseChartQtyconfig = {
    data: cropwiseChartQty,
    xField: "productName",
    yField: "totalQty",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Quantity",
      },
    },
    yAxis: {
      title: {
        text: "Product",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Area",
      },
      quantityBal: {
        alias: "Total Area",
      },
    },
  };

  const CropWiseChartValueConfig = {
    data: cropwiseChartQty,
    xField: "productName",
    yField: "totalValue",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Amount",
      },
    },
    yAxis: {
      title: {
        text: "Product",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Area",
      },
      quantityBal: {
        alias: "Total Area",
      },
    },
  };

  const configbar2 = {
    data: cropwiseYieldEstiamtionVSHarvest,
    isGroup: true,
    xField: "label",
    yField: "value",
    seriesField: "type",

    label: {
      position: "top",

      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
    },
    scrollbar: {
      type: "horizontal",
    },
  };

  const config = {
    data: cropwiseAreacovered,
    xField: "CropName",
    yField: "CropArea",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Area",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Area",
      },
      quantityBal: {
        alias: "Total Area",
      },
    },
  };

  const harvestconfig = {
    data: cropwiseHarvest,
    xField: "CropName",
    yField: "Quantity",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Quantity",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  const goodsIssueDetailConfig = {
    data: executivewiseGoodsIssueData,
    xField: "productTypeName",
    yField: "Amount",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Amount",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  const YieldEstiamtionconfig = {
    data: cropwiseYieldEstiamtion,
    xField: "CropName",
    yField: "Quantity",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Quantity",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  // const config = {
  //   data: data,
  //   xField: "productTitle",
  //   yField: "quantityBal",
  //   label: {
  //     position: "middle",

  //     style: {
  //       fill: "#FFFFFF",
  //       opacity: 0.6,
  //     },
  //   },
  //   xAxis: {
  //     label: {
  //       // autoHide: true,
  //       autoRotate: false,
  //       rotate: 220,
  //     },
  //     title: {
  //       text: "Products",
  //     },
  //   },
  //   yAxis: {
  //     title: {
  //       text: "stock",
  //     },
  //   },
  //   scrollbar: {
  //     type: "horizontal",
  //   },
  //   meta: {
  //     productTitle: {
  //       alias: "products",
  //     },
  //     quantityBal: {
  //       alias: "total stock",
  //     },
  //   },
  // };

  const { sendRequest: getWarehouseData } = useHttp();

  const handleChange = (event) => {
    //console.log(event.target.value);
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [selectedToDate, setSelectedToDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleToDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const fromDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // //console.log("emp",data.output )
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data);
      }
    );
  }, [getRegion]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <h2>Warehouse Dashboard</h2>
            </div>
            <div className="row"></div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Productwise Purchase</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    {/* <div className="row">
                      <div className="col-md-6">
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={regionCropArea}
                          onChange={(e) => {
                            setRegionCropArea(e.target.value);
                            loadcropwiseAreacovered(cropwiseAreacoveredAll, 0);
                          }}
                        >
                          <option>--All--</option>
                          <option value="Regionwise">Regionwise</option>
                          <option value="Executivewise">Executivewise</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        {regionCropArea == "Regionwise" ? (
                          <select
                            id="regionId"
                            className="form-control"
                            ref={(el) => (frmRef.current["regionId"] = el)}
                            value={regionId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Region--") {
                                id = e.target.value;
                              }
                              loadcropwiseAreacovered(
                                cropwiseAreacoveredAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Region--</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option
                                  key={x.regionId}
                                  user-id={x.regionId}
                                  value={x.regionId}
                                >
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_id"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Executive--") {
                                id = e.target.value;
                              }
                              loadcropwiseAreacovered(
                                cropwiseAreacoveredAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Executive--</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.userId}
                                  user-id={x.userId}
                                  value={x.userId}
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>
                    </div> */}
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      {/* &nbsp; <Column {...ProductWiseChartQtyconfig} />  */}
                      <DynamicColumnChart
                        data={productWiseChartQty}
                        xField="productName"
                        yField="totalQty"
                        xAxisTitle="Product"
                        yAxisTitle="Quantity"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Productwise Purchase Value</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    {/* <div className="row">
                      <div className="col-md-6">
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["salesreturnid"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            setRegionCropsHarvest(e.target.value);
                            loadcropwiseHarvestcovered(cropwiseHarvestAll, 0);
                          }}
                        >
                          <option>--All--</option>
                          <option value="Regionwise">Regionwise</option>
                          <option value="Executivewise">Executivewise</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        {regionCropsHarvest == "Regionwise" ? (
                          <select
                            id="regionId"
                            className="form-control"
                            ref={(el) => (frmRef.current["regionId"] = el)}
                            value={regionId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Region--") {
                                id = e.target.value;
                              }
                              loadcropwiseHarvestcovered(
                                cropwiseHarvestAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Region--</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option
                                  key={x.regionId}
                                  user-id={x.regionId}
                                  value={x.regionId}
                                >
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_id"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Executive--") {
                                id = e.target.value;
                              }
                              loadcropwiseHarvestcovered(
                                cropwiseHarvestAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Executive--</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.userId}
                                  user-id={x.userId}
                                  value={x.userId}
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>
                    </div> */}
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      &nbsp;{" "}
                      {/* <Column {...ProductWiseChartValueConfig} />{" "} */}
                      <DynamicColumnChart
                        data={productWiseChartQty}
                        xField="productName"
                        yField="totalValue"
                        xAxisTitle="Amount"
                        yAxisTitle="Product"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title"> Cropwise Produced</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    {/* <div className="row">
                    <div className="col-md-6">
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={regionCropArea}
                        onChange={(e) => {
                          setRegionCropsYieldEstiamtion(e.target.value);
                          loadcropwisecropsYieldEstiamtion(
                            cropwiseYieldEstiamtionAll,
                            0
                          );
                        }}
                      >
                        <option>--All--</option>
                        <option value="Regionwise">Regionwise</option>
                        <option value="Executivewise">Executivewise</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      {regionCropsYieldEstiamtion == "Regionwise" ? (
                        <select
                          id="regionId"
                          className="form-control"
                          ref={(el) => (frmRef.current["regionId"] = el)}
                          value={regionId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Region--") {
                              id = e.target.value;
                            }

                            loadcropwisecropsYieldEstiamtion(
                              cropwiseYieldEstiamtionAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Region--</option>
                          {regionData &&
                            regionData.map((x) => (
                              <option
                                key={x.regionId}
                                user-id={x.regionId}
                                value={x.regionId}
                              >
                                {x.regionName}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Executive--") {
                              id = e.target.value;
                            }
                            loadcropwisecropsYieldEstiamtion(
                              cropwiseYieldEstiamtionAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Executive--</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option
                                key={x.userId}
                                user-id={x.userId}
                                value={x.userId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      )}
                    </div>
                  </div> */}

                    <div style={{ width: "80%" }}>
                      &nbsp;
                      {/* <Column {...CropWiseChartQtyconfig} /> */}
                      <DynamicColumnChart
                        data={cropwiseChartQty}
                        xField="productName"
                        yField="totalQty"
                        xAxisTitle="Quantity"
                        yAxisTitle="Product"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">
                      Estimated Yield Vs. Actual Harvest
                    </h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    {/* <div className="row">
                    <div className="col-md-6">
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["salesreturnid"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          setRegionCropsYieldEstiamtionVSHarvest(
                            e.target.value
                          );
                          loadcropwisecropsYieldEstiamtionVSHarvest(
                            cropwiseYieldEstiamtionVSHarvestAll,
                            0
                          );
                        }}
                      >
                        <option>--All--</option>
                        <option value="Regionwise">Regionwise</option>
                        <option value="Executivewise">Executivewise</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      {regionCropsYieldEstiamtionVSHarvest == "Regionwise" ? (
                        <select
                          id="regionId"
                          className="form-control"
                          ref={(el) => (frmRef.current["regionId"] = el)}
                          value={regionId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Region--") {
                              id = e.target.value;
                            }
                            loadcropwisecropsYieldEstiamtionVSHarvest(
                              cropwiseYieldEstiamtionVSHarvestAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Region--</option>
                          {regionData &&
                            regionData.map((x) => (
                              <option
                                key={x.regionId}
                                user-id={x.regionId}
                                value={x.regionId}
                              >
                                {x.regionName}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Executive--") {
                              id = e.target.value;
                            }
                            loadcropwisecropsYieldEstiamtionVSHarvest(
                              cropwiseYieldEstiamtionVSHarvestAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Executive--</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option
                                key={x.userId}
                                user-id={x.userId}
                                value={x.userId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      )}
                    </div>
                  </div> */}

                    <div style={{ width: "80%" }}>
                      &nbsp;
                      {/* <Column {...CropWiseChartValueConfig} /> */}
                      <DynamicColumnChart
                        data={cropwiseChartQty}
                        xField="productName"
                        yField="totalValue"
                        xAxisTitle="Amount"
                        yAxisTitle="Product"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WarehouseChart;
